var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.vista && _vm.vista.config.legales)?_c('div',{staticClass:"legales-container"},[_c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.vista.config.legales),expression:"vista.config.legales"}],staticClass:"legales-container--content"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }